import { defineStyleConfig, defineStyle } from '@chakra-ui/react'
import { textStyles } from '../foundations'

const accessibleColorMap = {
  'btn-secondary': {
    color: 'btn-secondary.fontColor',
  },
}

// Note: There are no colors for "dark" mode
// since buttons will always be light themed
const variantSolid = defineStyle(props => {
  const { colorScheme } = props

  const {
    bg = `${colorScheme}.500`,
    color = `${colorScheme}.fontColor`,
    hoverBg = `${colorScheme}.600`,
    activeBg = `${colorScheme}.700`,
  } = accessibleColorMap[colorScheme] ?? {}

  return {
    bg,
    color,
    _hover: {
      bg: hoverBg,
      _disabled: {
        bg,
      },
    },
    _active: { bg: activeBg },
  }
})

const variantLink = defineStyle(props => {
  const { colorScheme, size } = props

  const { color = `${colorScheme}.500` } = accessibleColorMap[colorScheme] ?? {}

  return {
    ...textStyles[size],
    color,
  }
})

const variantGhost = defineStyle(props => {
  const { colorScheme } = props

  const { hoverBg = `${colorScheme}.50`, color = `${colorScheme}.700` } =
    accessibleColorMap[colorScheme] ?? {}

  return {
    color,
    _hover: {
      bg: hoverBg,
    },
  }
})

const variants = {
  link: variantLink,
  solid: variantSolid,
  ghost: variantGhost,
}

const sizes = {
  xs: defineStyle({
    ...textStyles['xs'],
  }),
  sm: defineStyle({
    ...textStyles['sm'],
  }),
  md: defineStyle({
    ...textStyles['md'],
  }),
  lg: defineStyle({
    ...textStyles['lg'],
  }),
}

export const Button = defineStyleConfig({
  variants,
  sizes,
  defaultProps: {
    variant: 'solid',
    size: 'md',
    colorScheme: 'btn-secondary',
  },
})
